import { computed } from 'vue';

export const useCurrentGroup = () => {
    const getCurrentGroupId = () => {
        return Spark.state.currentGroup?.group_id;
    };

    const roleOnCurrentGroup = Spark?.roleOnCurrentGroup;

    const currentGroup = computed(() => Spark.state.currentGroup);

    const onCorporate = () => {
        return !getCurrentGroupId();
    };

    const canAccessCorporate = computed(() => Spark.roleOnCurrentTeam !== 'none');

    const availableGroups = computed(() => {
        if (!Array.isArray(Spark.state.groups)) {
            console.error('Spark groups is not an array of groups.');
            return [];
        }
        const groups = Spark.state.groups;

        if (!currentGroup.value) {
            return groups;
        }

        // place current group on top of the list
        return groups.sort((a, b) => {
            if (a.group_id === currentGroup.value.group_id) {
                return -1;
            }
            if (b.group_id === currentGroup.value.group_id) {
                return 1;
            }
            return 0;
        });
    });

    return {
        canAccessCorporate,
        currentGroup,
        availableGroups,
        getCurrentGroupId,
        onCorporate,
        roleOnCurrentGroup,
    };
};
